<template>
  <div class="min-h-screen pt-20">
    <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <h1 class="text-3xl font-bold text-slate-100 mb-4">Quem Somos</h1>

      <p class="text-slate-300 leading-relaxed mb-4">
        O <span class="font-semibold text-slate-100">PowerAgents</span> é uma plataforma para <span class="font-semibold text-slate-100">criação e operação de agentes de IA</span> com arquitetura multi-tenant.
        Nosso objetivo é permitir que cada cliente tenha seu proprio ambiente para configurar agentes, prompts e integrações com APIs.
      </p>

      <p class="text-slate-300 leading-relaxed mb-4">
        A base do sistema reaproveita infraestrutura robusta de autenticação JWT, isolamento por tenant e homologação administrativa,
        para que os ambientes sejam aprovados e operem com segurança desde o início.
      </p>

      <p class="text-slate-300 leading-relaxed mb-4">
        O foco do produto é dar autonomia para empresas criarem quantos agentes precisarem, com responsabilidades diferentes
        (analise de dados, atendimento, automação de tarefas e outras operações).
      </p>

      <p class="text-slate-300 leading-relaxed mb-4">
        Esta versao representa o foundation do PowerAgents: tenant, usuários, login, aprovação admin, sitemap técnico e proteções anti-ataque.
      </p>

      <ul class="list-disc list-inside text-slate-300 space-y-1 mb-4 marker:text-cyan-400/80">
        <li>Cadastro de tenant com dados institucionais.</li>
        <li>Aprovação e inativação de tenants via modulo admin.</li>
        <li>Login com tokens separados para usuario e tenant.</li>
        <li>Estrutura SPA pronta para evolução do dominio de agentes.</li>
        <li>Sitemap dinâmico e base SEO técnica para crescimento.</li>
      </ul>

      <p class="text-slate-300 leading-relaxed mb-6">
        <span class="font-semibold text-slate-100">Nosso foco</span> é dar controle e clareza para quem opera agentes de IA em produção,
        com governança por ambiente e evolução segura do produto.
      </p>

      <div class="border-t border-cyan-400/20 pt-4 mt-4">
        <p class="text-slate-300">
          <span class="font-semibold text-2xl text-slate-100">Somos o PowerAgent</span><br />
          Plataforma para gestao de agentes de IA por ambiente.
        </p>
        <!-- <span class="text-sm text-slate-400">contato@poweragent.com.br</span> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About'
}
</script>
